// ============ PRODUCT PAGE JS ============
document.addEventListener('DOMContentLoaded', function () {

  function addClassesAndEvents() {
    const items = document.querySelectorAll('.order_sidual .ymq-option-value-item');

    if (items.length < 3) return false;

    // ✅ MAKING TIME WALI CLASSES
    const makingItems = document.querySelectorAll('.maikng_time .ymq-option-value-item');

    if (makingItems.length > 0) {
      makingItems[0].classList.add('regular');
    }
    if (makingItems.length > 1) {
      makingItems[1].classList.add('rush-order');
    }

    // ✅ DELIVERY SPEED WALI CLASSES
    items[0].classList.add('Standard');
    items[1].classList.add('Express');
    items[2].classList.add('ExpressSignature');

    // 👉 2-date range generator (NEW FORMAT)
    function getRangeText(minDays, maxDays) {
      const today = new Date();

      const start = new Date(today);
      start.setDate(today.getDate() + minDays);

      const end = new Date(today);
      end.setDate(today.getDate() + maxDays);

      const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
      const months   = ["January","February","March","April","May","June","July","August","September","October","November","December"];

      function getOrdinal(n) {
        if (n > 3 && n < 21) return n + "th";
        const last = n % 10;
        if (last === 1) return n + "st";
        if (last === 2) return n + "nd";
        if (last === 3) return n + "rd";
        return n + "th";
      }

      const startWeekday = weekdays[start.getDay()];
      const startMonth   = months[start.getMonth()];
      const startDayTxt  = getOrdinal(start.getDate());

      const endWeekday = weekdays[end.getDay()];
      const endMonth   = months[end.getMonth()];
      const endDayTxt  = getOrdinal(end.getDate());

      // "Thursday January 22nd - Thursday January 29th"
      return `${startWeekday} ${startMonth} ${startDayTxt} - ${endWeekday} ${endMonth} ${endDayTxt}`;
    }

    const timeLineSpan  = document.querySelector('.time_line_delavery span');
    const timeLineInput = document.querySelector('.time_line_delavery input');
    const hiddenInput   = document.querySelector('input.delivery-date');
    const hiddenType    = document.querySelector('input.delivery-type');
    const wrapper       = document.querySelector('.time_line_delavery');
    const defaultBox    = document.querySelector('.time_line_delavery .by_defolt_dayt');

    if (!timeLineSpan && !timeLineInput && !hiddenInput) return false;

    // ⭐ yaha FULL text (label + range) & ONLY range alag-alag set karenge
    function setDateText(fullText, rangeOnly) {
      if (timeLineSpan)  timeLineSpan.textContent = fullText;
      if (timeLineInput) timeLineInput.value      = fullText;

      // hidden property me sirf date range
      if (hiddenInput)   hiddenInput.value        = rangeOnly || fullText;
    }

    function showDefault() {
      if (defaultBox) {
        const rangeText = getRangeText(28, 42);
        defaultBox.textContent = `Estimated Delivery: ${rangeText}`;
                if (hiddenInput) hiddenInput.value = rangeText;
      }
    }

    function hideDefault() {
      if (defaultBox) defaultBox.textContent = '';
    }

    showDefault();

    function getCurrentSelection() {
      if (items[0].querySelector('input:checked')) return 'Standard';
      if (items[1].querySelector('input:checked')) return 'Express';
      if (items[2].querySelector('input:checked')) return 'ExpressSignature';

      if (items[0].classList.contains('ymq-checked')) return 'Standard';
      if (items[1].classList.contains('ymq-checked')) return 'Express';
      if (items[2].classList.contains('ymq-checked')) return 'ExpressSignature';

      return null;
    }

    function getMakingSelection() {
      if (!makingItems.length) return 'regular';

      function isChecked(el) {
        return el.querySelector('input:checked') || el.classList.contains('ymq-checked');
      }

      if (makingItems[0] && isChecked(makingItems[0])) return 'regular';
      if (makingItems[1] && isChecked(makingItems[1])) return 'rush-order';

      return 'regular';
    }

    function clearValues() {
      setDateText('', '');
      if (hiddenType)  hiddenType.value  = '';
      wrapper?.classList.remove('active');
    }

    // 🔥 main function – delivery + making combo
    function applyDateForCurrentSelection() {
      const selectedDelivery = getCurrentSelection();

      if (!selectedDelivery) {
        clearValues();
        showDefault();
        return;
      }

      hideDefault();
      wrapper?.classList.add('active');

      const makingType = getMakingSelection();
      let minDays = 28;
      let maxDays = 42;

      const label = 'Estimated Delivery:'; // FIXED label

      if (selectedDelivery === 'Standard') {
        if (makingType === 'regular')      { minDays = 28; maxDays = 42; }
        else /* rush */                    { minDays = 21; maxDays = 35; }
      }

      if (selectedDelivery === 'Express') {
        if (makingType === 'regular')      { minDays = 21; maxDays = 35; }
        else                               { minDays = 14; maxDays = 28; }
      }

      if (selectedDelivery === 'ExpressSignature') {
        if (makingType === 'regular')      { minDays = 21; maxDays = 35; }
        else                               { minDays = 14; maxDays = 28; }
      }

      const rangeText = getRangeText(minDays, maxDays);  // sirf dates
      const fullText  = `${label} ${rangeText}`;         // label + dates

      // 👇 UI me full text, hidden input me sirf range
      setDateText(fullText, rangeText);

      if (hiddenType) hiddenType.value = selectedDelivery;
    }

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        applyDateForCurrentSelection();
      });
    });

    makingItems.forEach(function (mItem) {
      mItem.addEventListener('click', function () {
        applyDateForCurrentSelection();
      });
    });

    return true;
  }

  if (addClassesAndEvents()) return;

  const interval = setInterval(() => {
    if (addClassesAndEvents()) clearInterval(interval);
  }, 300);

});



// ==========================================//
  // cart items title print javascript //
// ==========================================//
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".cart__item__content .cart__item__meta");
  if (!container) return;

  const properties = container.querySelectorAll(".cart__item__property");

  let shippingEl = null;
  let makingEl   = null;

  properties.forEach(p => {
    const strong = p.querySelector("strong");
    if (!strong) return;

    const text = strong.textContent.trim().toLowerCase();

    if (text.includes("shipping options")) {
      shippingEl = p;
    }

    if (text.includes("making time")) {
      makingEl = p;
    }
  });

  // 👉 dono element mil gaye to Making Time ko Shipping Option ke upar move karo
  if (shippingEl && makingEl) {
    container.insertBefore(makingEl, shippingEl);
  }
});



// ==========================================//
         // cart note javascript //
// ==========================================//

document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector(".cart_0rder____n0te");
  if (!wrapper) return;

  const title    = wrapper.querySelector(".cart__widget__title");
  const content  = wrapper.querySelector(".cart__widget__content");
  const closeBtn = wrapper.querySelector(".close_btn");

  const noteBox  = wrapper.querySelector("textarea");
  const saveBtn  = wrapper.querySelector("#order-note-save, .order-note-save, button");

  const cartNoteSpan = document.querySelector(".cart_not_msg_box span");
  const cartNoteBox  = document.querySelector(".cart_not_msg_box");

  // ⭐ msg close btn
  const msgClose = document.querySelector(".cart_not_msg_box .msg_close");

  let successMsg = wrapper.querySelector(".cart-note-success");
  if (!successMsg) {
    successMsg = document.createElement("div");
    successMsg.className = "cart-note-success";

    if (saveBtn && saveBtn.parentNode) {
      saveBtn.parentNode.appendChild(successMsg);
    } else {
      wrapper.appendChild(successMsg);
    }
  }

  if (!title || !content) return;

  // =========================
  // ⭐⭐ IMPORTANT PART ⭐⭐
  // Page load par, agar span me text hai → box dikhana
  // warna hide rakhna
  if (cartNoteBox) {
    const initialText = cartNoteSpan ? cartNoteSpan.textContent.trim() : "";
    if (initialText === "") {
      cartNoteBox.style.display = "none";   // note nahi → close
    } else {
      cartNoteBox.style.display = "block";  // note hai → open
    }
  }
  // =========================

  // Default accordion hidden
  content.style.display = "none";
  wrapper.classList.remove("active");

  // 👉 Toggle accordion
  title.addEventListener("click", function () {
    const isClosed = content.style.display === "none";
    content.style.display = isClosed ? "block" : "none";
    wrapper.classList.toggle("active", isClosed);
  });

  // 👉 Close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      content.style.display = "none";
      wrapper.classList.remove("active");
    });
  }

  // ⭐ SAVE → order note + success message + span update + auto close
  if (saveBtn && noteBox) {
    saveBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const text = noteBox.value.trim();
      if (text === "") return;

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: text })
      })
      .then(() => { 

        successMsg.style.display = "block";
        successMsg.textContent = "✔ Successfully Saved!";
        successMsg.style.color = "green";

        // span me text
        if (cartNoteSpan) {
          cartNoteSpan.textContent = text;
        }
        // ✅ ab sirf save hone ke baad hi box open hoga
        if (cartNoteBox) {
          cartNoteBox.style.display = "block";
        }

        // agar textarea empty karni ho to:
        // noteBox.value = "";

        // 1 sec baad order note accordion band
        setTimeout(() => {
          content.style.display = "none";
          wrapper.classList.remove("active");
        }, 1000);

        // 3 sec baad success msg hide
        setTimeout(() => {
          successMsg.style.display = "none";
        }, 3000);
      })
      .catch(() => {
        successMsg.style.display = "block";
        successMsg.textContent = "✖ Failed to Save! Try Again";
        successMsg.style.color = "red";

        setTimeout(() => {
          successMsg.style.display = "none";
        }, 3000);
      });
    });
  }

  // ⭐ CART MESSAGE CLOSE BUTTON LOGIC
  if (msgClose) {
    msgClose.addEventListener("click", function (e) {
      e.preventDefault();

      if (cartNoteSpan) cartNoteSpan.textContent = "";
      if (cartNoteBox)  cartNoteBox.style.display = "none";

      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: "" })
      }).catch(() => {
        console.warn("Failed to clear note");
      });
    });
  }

});

// ==========================================//
         // cart gift order javascript //
// ==========================================//


document.addEventListener("DOMContentLoaded", function () {

  const wrapper = document.querySelector(".cart_gift____n0te");
  if (!wrapper) return;

  const title   = wrapper.querySelector(".cart__widget__title");
  const content = wrapper.querySelector(".cart__widget__content");
  const closeBtn = wrapper.querySelector(".close_btn");

  const giftTextarea = wrapper.querySelector("textarea");
  const saveBtn = wrapper.querySelector("#order-note-save");

  // gift message box OUTSIDE
  const giftMsgBox  = document.querySelector(".cart_gift_msg_box");
  const giftMsgSpan = document.querySelector(".cart_gift_msg_box span");

  // message close button
  const msgCloseBtn = document.querySelector(".cart_gift_msg_box .msg_close");

  const innerBox = wrapper.querySelector(".cart__widget__content__inner");

  let successMsg = wrapper.querySelector(".gift-note-success");
  if (!successMsg) {
    successMsg = document.createElement("div");
    successMsg.className = "gift-note-success";
    successMsg.style.display = "none";
    successMsg.style.color = "green";
    successMsg.style.marginTop = "10px";
    innerBox.appendChild(successMsg);
  }

  // ⭐⭐ INITIAL STATE: agar span empty hai to box hide
  if (giftMsgBox) {
    if (!giftMsgSpan || giftMsgSpan.textContent.trim() === "") {
      giftMsgBox.style.display = "none";
    }
  }

  if (!title || !content) return;

  content.style.display = "none";
  wrapper.classList.remove("active");

  // OPEN / CLOSE
  title.addEventListener("click", function (e) {
    e.preventDefault();
    const isClosed = content.style.display === "none";
    content.style.display = isClosed ? "block" : "none";
    wrapper.classList.toggle("active", isClosed);
  });

  // CLOSE BUTTON
  if (closeBtn) {
    closeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      content.style.display = "none";
      wrapper.classList.remove("active");
    });
  }

  // SAVE BUTTON
  if (saveBtn && giftTextarea) {
    saveBtn.addEventListener("click", function (e) {
      e.preventDefault();

      const text = giftTextarea.value.trim();
      if (text === "") {
        // agar empty text save karoge to box hide
        if (giftMsgBox) giftMsgBox.style.display = "none";
        if (giftMsgSpan) giftMsgSpan.textContent = "";
        return;
      }

      // success message
      successMsg.textContent = "✔ Successfully Saved!";
      successMsg.style.display = "block";

      // span me text
      if (giftMsgSpan) giftMsgSpan.textContent = text;

      // sirf tab show karo jab span me text ho
      if (giftMsgBox && giftMsgSpan.textContent.trim() !== "") {
        giftMsgBox.style.display = "block";
      }

      // auto close panel
      setTimeout(() => {
        content.style.display = "none";
        wrapper.classList.remove("active");
      }, 800);

      setTimeout(() => {
        successMsg.style.display = "none";
      }, 3000);
    });
  }

  // MESSAGE BOX CLOSE BUTTON
  if (msgCloseBtn) {
    msgCloseBtn.addEventListener("click", function (e) {
      e.preventDefault();

      if (giftMsgBox) giftMsgBox.style.display = "none";
      if (giftMsgSpan) giftMsgSpan.textContent = "";
    });
  }

});


// ==========================================//
  // Shiping dayt auto change javascript //


  // id="privacy-todaydate"
// ==========================================//

document.addEventListener("DOMContentLoaded", function () {

  // STEP 1: Target container
  const container = document.querySelector("#privacy-policy-policy-modal .dayt_ato");
  if (!container) return;

  // STEP 2: Create new DIV for today date
  let todayBox = document.createElement("div");
  todayBox.className = "today_dayts";

  // STEP 3: Generate today's date (auto-updating daily)
  const today = new Date();

  // const weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
  const months   = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  // const dayName = weekdays[today.getDay()];
  const monthName = months[today.getMonth()];
  const day = today.getDate();
  const year = today.getFullYear();

  // final format example: "Today: Monday, January 27, 2025"
  todayBox.textContent = ` ${monthName} ${day}, ${year}`;

  // STEP 4: Append inside .dayt_ato
  container.appendChild(todayBox);

});

// ==========================================//
  // announcement header //
// ==========================================//
document.addEventListener("DOMContentLoaded", function () {

  var swiper = new Swiper(".annou_swiper", {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    }
  });

});


//  ---------------------------------------------- //
//              matl type tab js                   //
//  ---------------------------------------------- //

document.addEventListener("DOMContentLoaded", function () {
  function norm(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  // ✅ UPDATED CLEANER (handles ":" and ":-" and any weird separators)
  function cleanMetalLabel(text) {
    let t = norm(text);
    if (!t) return "";

    // Remove leading "Metal Type" with any separators like ":" / ":-" / "-:" / "--" etc
    t = t.replace(/^metal\s*type\s*[:\-–—]*\s*/i, "");

    // Remove any leading separators left behind (like "- Silver")
    t = t.replace(/^[:\-–—\s]+/, "");

    return norm(t);
  }

  function setOptionTitle(radioBtn, newText) {
    const title = radioBtn.querySelector(".option-title");
    if (title) title.textContent = newText;
  }

  function getOptionTitleLower(radioBtn) {
    const title = radioBtn.querySelector(".option-title");
    return norm(title ? title.textContent : radioBtn.textContent).toLowerCase();
  }

  document.querySelectorAll(".radio__fieldset").forEach(function (fieldset) {
    var optionName = fieldset.querySelector(".radio__legend .radio__legend__option-name");
    if (!optionName || norm(optionName.textContent) !== "Metal Type") return;

    var radioButtons = fieldset.querySelector(".radio__buttons");
    if (!radioButtons) return;

    radioButtons.classList.add("metal_type_main");

    /* ===============================
       CLEAN LABELS: remove "Metal Type" + separators from ALL radios
    =============================== */
    var initialRadioItems = Array.from(radioButtons.querySelectorAll(".radio__button"));
    initialRadioItems.forEach(function (radioBtn) {
      var input = radioBtn.querySelector('input[type="radio"]');
      var raw = input ? input.value : radioBtn.textContent;

      // ✅ Use updated cleaner
      var cleaned = cleanMetalLabel(raw);

      if (cleaned) setOptionTitle(radioBtn, cleaned);
    });

    /* ===============================
       CREATE TABS UL (your structure)
    =============================== */
    var ul = radioButtons.querySelector(".metal-type-tabs");
    if (!ul) {
      ul = document.createElement("ul");
      ul.className = "metal-type-tabs";

      for (var i = 1; i <= 3; i++) {
        var li = document.createElement("li");
        var a = document.createElement("a");
        a.href = "javascript:void(0)";
        li.appendChild(a);
        ul.appendChild(li);
      }

      radioButtons.prepend(ul);
    }

    var firstTabAnchor = ul.querySelector("li:nth-child(1) a"); // Silver
    var secandTabAnchor = ul.querySelector("li:nth-child(2) a"); // Gold
    var thirdTabAnchor = ul.querySelector("li:nth-child(3) a"); // Platinum

    // Ensure second li has class "gold"
    var allLis = ul.querySelectorAll("li");
    var secondLi = ul.querySelector("li:nth-child(2)");
    if (secondLi) secondLi.classList.add("gold");

    // IMPORTANT: clear previous moved nodes (if rerun)
    if (firstTabAnchor) firstTabAnchor.innerHTML = "";
    if (secandTabAnchor) secandTabAnchor.innerHTML = "";
    if (thirdTabAnchor) thirdTabAnchor.innerHTML = "";

    /* ===============================
       MOVE EXISTING RADIOS INTO TABS (Silver/Gold/Platinum)
    =============================== */
    var radioItems = Array.from(radioButtons.querySelectorAll(".radio__button"));

    var silverRadio = null;
    var platinumRadio = null;

    radioItems.forEach(function (radioBtn) {
      var text = getOptionTitleLower(radioBtn);

      if (text === "silver") silverRadio = radioBtn;
      if (text.includes("platinum")) platinumRadio = radioBtn;
    });

    if (silverRadio && firstTabAnchor) firstTabAnchor.appendChild(silverRadio);
    if (platinumRadio && thirdTabAnchor) thirdTabAnchor.appendChild(platinumRadio);

    /* ===============================
       🔥 KEEP YOUR CUSTOM GOLD RADIO BUTTON LOGIC
    =============================== */
    if (secondLi) {
      var goldAnchor = secondLi.querySelector("a");

      if (goldAnchor && !goldAnchor.querySelector(".radio__button.metal-gold-trigger")) {
        var radioSpan = document.createElement("span");
        radioSpan.className = "radio__button metal-gold-trigger";

        var input = document.createElement("input");
        input.type = "radio";
        input.name = "metal_type_custom";
        input.value = "Gold";

        var label = document.createElement("label");

        var titleSpan = document.createElement("span");
        titleSpan.className = "option-title";
        titleSpan.textContent = "Gold";

        label.appendChild(titleSpan);
        radioSpan.appendChild(input);
        radioSpan.appendChild(label);
        goldAnchor.appendChild(radioSpan);
      }
    }

    /* ===============================
       CREATE / GET CONTENT BOX (sub options)
    =============================== */
    var contentDiv = radioButtons.querySelector(".metal-tabs-content");
    if (!contentDiv) {
      contentDiv = document.createElement("div");
      contentDiv.className = "metal-tabs-content";
      ul.insertAdjacentElement("afterend", contentDiv);
    }

    /* ===============================
       MOVE REMAINING RADIOS INTO contentDiv
    =============================== */
    var tabbedSet = new Set([silverRadio, platinumRadio]);

    Array.from(radioButtons.querySelectorAll(".radio__button")).forEach(function (btn) {
      if (btn.closest(".metal-type-tabs")) return;
      if (btn.classList.contains("metal-gold-trigger")) return;
      if (tabbedSet.has(btn)) return;

      contentDiv.appendChild(btn);
    });

    /* ===============================
       CLICK LOGIC
    =============================== */
    function setActive(li) {
      allLis.forEach(function (l) {
        l.classList.remove("active");
      });
      li.classList.add("active");
    }

    allLis.forEach(function (li) {
      li.addEventListener("click", function () {
        setActive(li);

        if (li.classList.contains("gold")) {
          contentDiv.classList.add("active");

          contentDiv.querySelectorAll(".radio__button").forEach(function (btn) {
            btn.classList.remove("active");
          });

          var firstRadioBtn = contentDiv.querySelector(".radio__button");
          if (firstRadioBtn) {
            firstRadioBtn.classList.add("active");
            var inp = firstRadioBtn.querySelector("input");
            if (inp) {
              inp.checked = true;
              inp.dispatchEvent(new Event("change", { bubbles: true }));
              inp.dispatchEvent(new Event("input", { bubbles: true }));
            }
          }
        } else {
          contentDiv.classList.remove("active");

          var tabInput = li.querySelector('input[type="radio"]');
          if (tabInput) {
            tabInput.checked = true;
            tabInput.dispatchEvent(new Event("change", { bubbles: true }));
            tabInput.dispatchEvent(new Event("input", { bubbles: true }));
          }
        }
      });
    });

    /* ===============================
       DEFAULT ACTIVE: Silver if exists else Gold
    =============================== */
    var firstLi = ul.querySelector("li:nth-child(1)");
    if (firstLi && firstTabAnchor && firstTabAnchor.querySelector('input[type="radio"]')) {
      firstLi.click();
    } else if (secondLi) {
      secondLi.click();
    }
  });
});









// ================= Center stone tb / Stone Type js =================== //


document.addEventListener("DOMContentLoaded", function () {

  function norm(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  /* =========================
     CT LOGIC (CENTER STONE TYPE)
  ========================= */
  function addCtIfPureNumber(text) {
    const t = norm(text);
    if (!t) return t;
    if (/\bct\b/i.test(t)) return t;
    if (/^\d+(\.\d+)?$/.test(t)) return t + " CT";
    return t;
  }

  function applyCtToOneRadio(radioBtnEl) {
    if (!radioBtnEl) return;

    const label =
      radioBtnEl.querySelector("label") ||
      radioBtnEl.closest("label");

    if (!label) return;

    const textEl =
      label.querySelector(".option-title") ||
      label.querySelector("span") ||
      label;

    const before = norm(textEl.textContent);
    const after = addCtIfPureNumber(before);

    if (before !== after) {
      textEl.textContent = after;
    }
  }

  function applyCt(container) {
    if (!container) return;
    container.querySelectorAll(".radio__button").forEach(applyCtToOneRadio);
  }

  function observeCt(container) {
    if (!container) return;
    const mo = new MutationObserver(() => applyCt(container));
    mo.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* =========================
     🔢 SORT NUMERIC RADIOS (CENTER STONE TYPE)
  ========================= */
  function sortCenterStoneRadiosByNumber(contentDiv) {
    if (!contentDiv) return;

    contentDiv
      .querySelectorAll(".center-stone .radio__buttons")
      .forEach(function (buttons) {

        const radios = Array.from(
          buttons.querySelectorAll(".radio__button")
        );

        const numericRadios = radios
          .map(function (rb) {
            const titleEl = rb.querySelector(".option-title");
            if (!titleEl) return null;

            const num = parseFloat(
              titleEl.textContent.replace(/[^0-9.]/g, "")
            );

            if (isNaN(num)) return null;
            return { el: rb, num };
          })
          .filter(Boolean);

        numericRadios
          .sort((a, b) => a.num - b.num)
          .forEach(item => {
            buttons.appendChild(item.el);
          });
      });
  }

  function hasDigit(s) {
    return /\d/.test(String(s || ""));
  }

  function removeIfExists(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* =========================
     STONE TYPE HELPERS (KEEP AS-IS)
  ========================= */
  function toOnlyCt(text) {
    const t = norm(text);
    const m = t.match(/(\d+(\.\d+)?)/);
    if (!m) return t;
    return m[1] + " CT";
  }

  function cleanStoneTypeLabel(text) {
    const t = norm(text);
    if (/\d/.test(t)) {
      return addCtIfPureNumber(toOnlyCt(t));
    }
    return t.replace(/^stone type\s*:\s*/i, "");
  }

  function cleanStoneTypeFieldset(fieldset) {
    const topRadioButtons = fieldset.querySelector(":scope > .radio__buttons");
    if (!topRadioButtons) return;

    topRadioButtons.querySelectorAll(".radio__button").forEach(function (rb) {
      const label = rb.querySelector("label") || rb.closest("label");
      if (!label) return;

      const textEl =
        label.querySelector(".option-title") ||
        label.querySelector(".radio__label") ||
        label.querySelector(".radio__text") ||
        label.querySelector("span") ||
        label;

      const before = norm(textEl.textContent);
      const after = cleanStoneTypeLabel(before);
      if (before !== after) textEl.textContent = after;
    });

    const legendValue = fieldset.querySelector(".radio__legend__value");
    if (legendValue) {
      const before = norm(legendValue.textContent);
      const after = cleanStoneTypeLabel(before);
      if (before !== after) legendValue.textContent = after;
    }
  }

  function observeCleanup(fieldset) {
    const mo = new MutationObserver(function () {
      cleanStoneTypeFieldset(fieldset);
    });
    mo.observe(fieldset, { childList: true, subtree: true, characterData: true });
    return mo;
  }

  function moveMoissaniteStoneType(fieldset) {
    if (!fieldset.classList.contains("center_tone_type")) return;

    const sourceButtons = fieldset.querySelector(":scope > .radio__buttons");
    const centerStones = fieldset.querySelectorAll(".center_tone_content .center-stone");

    if (!sourceButtons || centerStones.length < 2) return;

    const moissaniteTarget = centerStones[0].querySelector(".radio__buttons");
    const labTarget = centerStones[1].querySelector(".radio__buttons");

    if (!moissaniteTarget || !labTarget) return;

    sourceButtons.querySelectorAll(".radio__button").forEach(function (rb) {
      const input = rb.querySelector('input[type="radio"]');
      const text = norm(input ? input.value : rb.textContent).toLowerCase();

      if (text.includes("stone type") && text.includes("moissanite")) {
        moissaniteTarget.appendChild(rb);
      }

      if (text.includes("stone type") && (text.includes("lab") || text.includes("diamond"))) {
        labTarget.appendChild(rb);
      }
    });
  }

  function sortAndStackNumericRadios(container) {
    if (!container) return;

    const buttons = Array.from(container.querySelectorAll(".radio__button"));

    const parsed = buttons
      .map((btn) => {
        const title = btn.querySelector(".option-title");
        if (!title) return null;

        const numMatch = title.textContent.match(/(\d+(\.\d+)?)/);
        if (!numMatch) return null;

        return { btn, value: parseFloat(numMatch[1]) };
      })
      .filter(Boolean);

    parsed
      .sort((a, b) => a.value - b.value)
      .forEach(({ btn }) => container.appendChild(btn));
  }

  /* =========================
     ✅ CENTER STONE TYPE CLEANER (ADDED)
  ========================= */
  function cleanCenterStoneTypeLabel(text) {
    const t = norm(text);
    if (/\d/.test(t)) {
      return addCtIfPureNumber(toOnlyCt(t));
    }
    return t.replace(/^center stone type\s*:\s*/i, "");
  }

  function cleanCenterStoneTypeFieldset(fieldset) {
    const topRadioButtons = fieldset.querySelector(":scope > .radio__buttons");
    if (!topRadioButtons) return;

    topRadioButtons.querySelectorAll(".radio__button").forEach(function (rb) {
      const label = rb.querySelector("label") || rb.closest("label");
      if (!label) return;

      const textEl =
        label.querySelector(".option-title") ||
        label.querySelector(".radio__label") ||
        label.querySelector(".radio__text") ||
        label.querySelector("span") ||
        label;

      const before = norm(textEl.textContent);
      const after = cleanCenterStoneTypeLabel(before);
      if (before !== after) textEl.textContent = after;
    });

    const legendValue = fieldset.querySelector(".radio__legend__value");
    if (legendValue) {
      const before = norm(legendValue.textContent);
      const after = cleanCenterStoneTypeLabel(before);
      if (before !== after) legendValue.textContent = after;
    }
  }

  function observeCenterCleanup(fieldset) {
    const mo = new MutationObserver(function () {
      cleanCenterStoneTypeFieldset(fieldset);
    });
    mo.observe(fieldset, { childList: true, subtree: true, characterData: true });
    return mo;
  }

  /* =========================
     MAIN (COMBINED)
  ========================= */
  document.querySelectorAll(".radio__fieldset").forEach(function (fieldset) {

    const optionName =
      fieldset.querySelector(".radio__legend__option-name");

    if (!optionName) return;

    const optText = norm(optionName.textContent).toLowerCase();

    const isCenterStoneType = optText === "center stone type";
    const isStoneType = optText === "stone type";

    if (!isCenterStoneType && !isStoneType) return;

    const topRadioButtons =
      fieldset.querySelector(":scope > .radio__buttons");

    if (!topRadioButtons) return;

    const radios = Array.from(
      topRadioButtons.querySelectorAll(".radio__button")
    );

    if (!radios.length) return;

    /* =========================
       CENTER STONE TYPE FLOW
    ========================= */
    if (isCenterStoneType) {
      fieldset.classList.add("center_tone_type");

      applyCt(topRadioButtons);
      observeCt(topRadioButtons);

      cleanCenterStoneTypeFieldset(fieldset);
      observeCenterCleanup(fieldset);

      const anyHasNumber = radios.some(r => hasDigit(r.textContent));

      // ✅ FIX: if NO numbers, do NOT create tabs/split UI
      if (!anyHasNumber) return;

      removeIfExists(fieldset.querySelector(".center-tone-ul"));
      removeIfExists(fieldset.querySelector(".center_tone_content"));

      const ul = document.createElement("div");
      ul.className = "center-tone-ul";

      const btnM = document.createElement("div");
      btnM.textContent = "Moissanite";
      btnM.className = "center-stone-btn moissanite_btn active";

      const btnL = document.createElement("div");
      btnL.textContent = "Lab Diamond";
      btnL.className = "center-stone-btn lab_btn";

      ul.append(btnM, btnL);
      fieldset.appendChild(ul);

      const contentDiv = document.createElement("div");
      contentDiv.className = "center_tone_content";
      ul.after(contentDiv);

      observeCt(contentDiv);

      for (let i = 0; i < 2; i++) {
        const stone = document.createElement("span");
        stone.className = "center-stone";
        stone.style.display = i === 0 ? "block" : "none";

        const inner = document.createElement("div");
        inner.className = "radio__buttons";

        stone.appendChild(inner);
        contentDiv.appendChild(stone);
      }

      const stones = contentDiv.querySelectorAll(".center-stone");

      btnM.onclick = () => {
        btnM.classList.add("active");
        btnL.classList.remove("active");
        stones[0].style.display = "block";
        stones[1].style.display = "none";
      };

      btnL.onclick = () => {
        btnL.classList.add("active");
        btnM.classList.remove("active");
        stones[1].style.display = "block";
        stones[0].style.display = "none";
      };

      radios.forEach(function (radio) {
        const input = radio.querySelector('input[type="radio"]');
        if (!input) return;

        const v = norm(input.value).toLowerCase();

        if (v.includes("moissanite")) {
          stones[0].querySelector(".radio__buttons").appendChild(radio);
        } else if (v.includes("lab") || v.includes("diamond")) {
          stones[1].querySelector(".radio__buttons").appendChild(radio);
        }
      });

      applyCt(contentDiv);

      cleanCenterStoneTypeFieldset(fieldset);
      cleanCenterStoneTypeFieldset(contentDiv);

      sortCenterStoneRadiosByNumber(contentDiv);

      return;
    }

    /* =========================
       STONE TYPE FLOW
    ========================= */
    if (isStoneType) {

      applyCt(topRadioButtons);
      observeCt(topRadioButtons);

      cleanStoneTypeFieldset(fieldset);
      observeCleanup(fieldset);

      const anyHasNumber = radios.some((r) => hasDigit(norm(r.textContent)));

      if (!anyHasNumber) return;

      fieldset.classList.add("center_tone_type");

      removeIfExists(fieldset.querySelector(".center-tone-ul"));
      removeIfExists(fieldset.querySelector(".center_tone_content"));

      const ul = document.createElement("div");
      ul.className = "center-tone-ul";

      const btnMoissanite = document.createElement("div");
      btnMoissanite.textContent = "Moissanite";
      btnMoissanite.classList.add("moissanite_btn", "center-stone-btn");

      const btnLab = document.createElement("div");
      btnLab.textContent = "Lab Diamond";
      btnLab.classList.add("lab_btn", "center-stone-btn");

      ul.appendChild(btnMoissanite);
      ul.appendChild(btnLab);
      fieldset.appendChild(ul);

      function setActiveButton(which) {
        ul.querySelectorAll(".center-stone-btn").forEach((b) => b.classList.remove("active"));
        if (which === "moissanite") btnMoissanite.classList.add("active");
        if (which === "lab") btnLab.classList.add("active");
      }

      const contentDiv = document.createElement("div");
      contentDiv.className = "center_tone_content";
      ul.insertAdjacentElement("afterend", contentDiv);

      observeCt(contentDiv);

      for (let i = 0; i < 2; i++) {
        const span = document.createElement("span");
        span.className = "center-stone";
        span.style.display = "none";

        const innerDiv = document.createElement("div");
        innerDiv.className = "radio__buttons";
        span.appendChild(innerDiv);

        contentDiv.appendChild(span);
      }

      const centerStones = contentDiv.querySelectorAll(".center-stone");

      btnMoissanite.addEventListener("click", function () {
        setActiveButton("moissanite");
        centerStones.forEach((s) => (s.style.display = "none"));
        centerStones[0].style.display = "block";
      });

      btnLab.addEventListener("click", function () {
        setActiveButton("lab");
        centerStones.forEach((s) => (s.style.display = "none"));
        centerStones[1].style.display = "block";
      });

      moveMoissaniteStoneType(fieldset);

      cleanStoneTypeFieldset(fieldset);
      cleanStoneTypeFieldset(contentDiv);

      contentDiv.querySelectorAll(".radio__buttons").forEach(sortAndStackNumericRadios);

      applyCt(contentDiv);

      btnMoissanite.click();

      return;
    }
  });
});














// ======= GOLD COLOR HIDE AND SHOW LOGIC

// Gold Color show/hide + required toggle + default select first option only when Gold is active

function isGoldSelected() {
  const goldActive = document.querySelector('.metal-type-tabs li.gold.active');
  if (goldActive) return true;

  // fallback (if theme ever stops using li.active)
  const checked = document.querySelector('input[name^="options[Metal Type]-"]:checked');
  return !!(checked && checked.value && checked.value.trim().toLowerCase() === 'gold');
}

function showEl(el) {
  el.classList.remove('d-none', 'hidden', 'hide', 'is-hidden');
  el.hidden = false;
  el.style.setProperty('display', 'block', 'important');
  el.style.setProperty('visibility', 'visible', 'important');
  el.style.setProperty('opacity', '1', 'important');
}

function hideEl(el) {
  el.style.setProperty('display', 'none', 'important');
}

function setGoldRequired(wrap, required) {
  wrap.querySelectorAll('input[name="properties[Gold Color]"]').forEach((inp) => {
    inp.required = required;
  });
}

function clearGoldColor(wrap) {
  wrap.querySelectorAll('input[name="properties[Gold Color]"]').forEach((inp) => {
    inp.checked = false;
  });

  const legendValue = wrap.querySelector('.radio__legend__value');
  if (legendValue) legendValue.textContent = '';
}

function selectFirstGoldColor(wrap) {
  const first = wrap.querySelector('input[name="properties[Gold Color]"]');
  if (!first) return;

  // don't override user's selection
  const already = wrap.querySelector('input[name="properties[Gold Color]"]:checked');
  if (already) return;

  first.checked = true;
  first.dispatchEvent(new Event('change', { bubbles: true }));

  const legendValue = wrap.querySelector('.radio__legend__value');
  if (legendValue) legendValue.textContent = first.value || '';
}

function toggleGoldColor() {
  const show = isGoldSelected();

  document.querySelectorAll('[data-gold-color-wrapper]').forEach((wrap) => {
    if (show) {
      showEl(wrap);
      setGoldRequired(wrap, true);

      // default select first option ONLY when gold is active
      setTimeout(() => selectFirstGoldColor(wrap), 0);
    } else {
      hideEl(wrap);
      setGoldRequired(wrap, false);
      clearGoldColor(wrap);
    }

    const parent = wrap.closest('.selector-wrapper, .product__block, .radio__fieldset, fieldset');
    if (show && parent) showEl(parent);
  });
}

// Init
document.addEventListener('DOMContentLoaded', toggleGoldColor);
document.addEventListener('shopify:section:load', toggleGoldColor);

// When clicking tabs
document.addEventListener('click', (e) => {
  if (e.target.closest('.metal-type-tabs')) setTimeout(toggleGoldColor, 0);
});

// When changing metal type radios (fallback)
document.addEventListener('change', (e) => {
  if (e.target && e.target.matches('input[name^="options[Metal Type]-"]')) toggleGoldColor();
});

// Keep in sync if theme changes classes dynamically
new MutationObserver(() => {
  // tiny debounce to avoid spam
  clearTimeout(window.__goldColorObsT);
  window.__goldColorObsT = setTimeout(toggleGoldColor, 0);
}).observe(document.documentElement, { childList: true, subtree: true });



  
    // REMOVE TEXT FROM CENTER STONE TYPE

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.center-stone .option-title').forEach(function (el) {
      el.textContent = el.textContent.replace(/[^0-9.]/g, '');
    });
  });

  // SIDE STONE TYPE LABEL CHANGE =============================================

document.addEventListener("DOMContentLoaded", function () {

  function cleanValue(val) {
    if (!val) return "";

    // Take last part after colon
    let text = val.split(":").pop().trim().toLowerCase();

    if (text.includes("moiss")) return "Moissanite";
    if (text.includes("lab") || text.includes("grown") || text.includes("diamond")) {
      return "Lab Diamond";
    }

    return text;
  }

  document.querySelectorAll(".selector-wrapper").forEach(function (wrapper) {

    const optionNameEl = wrapper.querySelector(".radio__legend__option-name");
    if (!optionNameEl) return;

    // STRICT check
    if (optionNameEl.textContent.trim() !== "Side Stone Type") return;

    const legendValueEl = wrapper.querySelector(".radio__legend__value");

    // Update radio labels
    wrapper.querySelectorAll(".radio__button").forEach(function (btn) {
      const input = btn.querySelector('input[type="radio"]');
      const title = btn.querySelector(".option-title");

      if (!input || !title) return;

      title.textContent = cleanValue(input.value);
    });

    // Sync legend value
    function updateLegend() {
      const checked = wrapper.querySelector('input[type="radio"]:checked');
      if (!checked || !legendValueEl) return;

      legendValueEl.textContent = cleanValue(checked.value);
      legendValueEl.setAttribute("data-option-value", checked.value);
    }

    wrapper.addEventListener("change", function (e) {
      if (e.target.matches('input[type="radio"]')) {
        updateLegend();
      }
    });

    updateLegend();
  });

});




// GOLD COLOR SEQUENCE AND NAME AND TOOLTIP =======================

document.addEventListener("DOMContentLoaded", () => {
  const wrapper = document.querySelector(".selector-wrapper.gold-color");
  if (!wrapper) return;

  const desired = ["Yellow", "White", "Rose"];
  const tooltipText = {
    yellow: "Yellow Gold",
    white: "White Gold",
    rose: "Rose Gold"
  };

  const buttons = Array.from(wrapper.querySelectorAll(".radio__buttons .radio__button"));
  if (buttons.length < 3) return;

  // Save previous checked state
  const currentByValue = {};
  buttons.forEach((btn) => {
    const input = btn.querySelector("input[type='radio']");
    const title = btn.querySelector(".option-title");
    const val = (input?.value || title?.textContent || "").trim();
    if (!val) return;
    currentByValue[val.toLowerCase()] = { checked: !!input?.checked };
  });

  // Stable base id
  const baseId = (() => {
    const firstInput = buttons[0].querySelector("input[type='radio']");
    if (!firstInput?.id) return "gold-color";
    return firstInput.id.replace(/-\d+$/, "");
  })();

  // Create tooltip element once
  let tipEl = document.querySelector(".mv-swatch-tooltip");
  if (!tipEl) {
    tipEl = document.createElement("div");
    tipEl.className = "mv-swatch-tooltip";
    document.body.appendChild(tipEl);
  }

  const stripAllTooltips = (el) => {
    if (!el) return;
    el.removeAttribute("title");
    el.removeAttribute("data-tooltip");
    el.querySelectorAll("[title]").forEach((n) => n.removeAttribute("title"));
    el.querySelectorAll("[data-tooltip]").forEach((n) => n.removeAttribute("data-tooltip"));
  };

  const showTipBelowElement = (text, element) => {
    if (!element) return;

    tipEl.textContent = text;
    tipEl.classList.add("is-visible");

    // Reset to measure size correctly
    tipEl.style.left = "0px";
    tipEl.style.top = "0px";

    const r = element.getBoundingClientRect();
    const tr = tipEl.getBoundingClientRect();

    const gap = 10;
    let left = r.left + r.width / 2 - tr.width / 2;
    let top = r.bottom + gap;

    // Keep inside viewport
    const pad = 8;
    left = Math.max(pad, Math.min(left, window.innerWidth - tr.width - pad));

    tipEl.style.left = `${left}px`;
    tipEl.style.top = `${top}px`;
  };

  const hideTip = () => tipEl.classList.remove("is-visible");

  // Hide tooltip when tapping/clicking outside (mobile + desktop)
  const isTapInside = (target) =>
    target.closest(".radio__button") || target.closest(".mv-swatch-tooltip");

  document.addEventListener("pointerdown", (e) => {
    if (!isTapInside(e.target)) {
      hideTip();
    }
  });


  desired.forEach((want, i) => {
    const slotBtn = buttons[i]; // span.radio__button
    const input = slotBtn.querySelector("input[type='radio']");
    const label = slotBtn.querySelector("label");
    const title = slotBtn.querySelector(".option-title");
    if (!input) return;

    const wantKey = want.toLowerCase();
    const prev = currentByValue[wantKey] || { checked: false };
    const tip = tooltipText[wantKey] || want;

    // Update visible text
    if (title) title.textContent = want;

    // Update id/value
    const newId = `${baseId}-${i + 1}`;
    input.value = want;
    input.id = newId;
    if (label) label.setAttribute("for", newId);

    // Restore checked state
    input.checked = !!prev.checked;

    // Blank label but clickable
    if (label) {
      label.textContent = "";
      label.setAttribute("aria-hidden", "true");
      label.style.pointerEvents = "auto";
      label.style.cursor = "pointer";
    }

    // Remove native/theme tooltip triggers to avoid double tooltips
    stripAllTooltips(slotBtn);
    stripAllTooltips(input);
    stripAllTooltips(label);
    stripAllTooltips(title);

    const hoverTarget = label || slotBtn;

    // Mobile tap support
    hoverTarget.addEventListener("click", (e) => {
      e.stopPropagation(); // prevent outside handler from closing it
      showTipBelowElement(tip, slotBtn);
    });


    const reposition = () => {
      if (tipEl.classList.contains("is-visible")) showTipBelowElement(tip, slotBtn);
    };

    hoverTarget.addEventListener("mouseenter", () => showTipBelowElement(tip, slotBtn));
    hoverTarget.addEventListener("mouseleave", hideTip);

    // Keyboard
    input.addEventListener("focus", () => showTipBelowElement(tip, slotBtn));
    input.addEventListener("blur", hideTip);

    window.addEventListener("scroll", reposition, { passive: true });
    window.addEventListener("resize", reposition);
  });

  // Sync legend on change
  const legendValue = wrapper.querySelector(".radio__legend__value");
  wrapper.querySelectorAll("input[type='radio']").forEach((radio) => {
    radio.addEventListener("change", (e) => {
      if (!legendValue) return;
      legendValue.textContent = e.target.value;
      legendValue.setAttribute("data-option-value", e.target.value);
    });
  });
});





// contact 

